var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullseye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A3365;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.95,95.93C24.58,95.92,4,75.34,4,49.97C4,24.64,24.61,4.06,50,4.07c25.3,0.01,46.08,20.76,46,45.95 C95.92,75.36,75.29,95.93,49.95,95.93z M49.92,84.17c19.28,0,34.4-14.99,34.43-34.13c0.03-19.06-15.26-34.37-34.33-34.38 c-19.12-0.01-34.37,15.19-34.4,34.29C15.59,69.15,30.65,84.17,49.92,84.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.89,73.63C36.58,73.6,26.31,63.26,26.32,49.91c0.02-13.22,10.5-23.67,23.72-23.65 c13.15,0.02,23.68,10.64,23.6,23.8C73.56,63.36,63.18,73.67,49.89,73.63z M61.98,49.95c-0.01-6.49-5.34-11.83-11.86-11.9 c-6.72-0.07-12.13,5.29-12.1,12c0.03,6.45,5.42,11.92,11.82,11.99C56.38,62.11,61.99,56.53,61.98,49.95z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/bullseye.92e89aa3f1c9563c372d626df3dd82ac.svg";
export { ForwardRef as ReactComponent };